var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { ClassifierService } from '@synisys/idm-classifier-service-client-js';
import { DeService } from '@synisys/idm-de-service-client-js';
import { KbService, MetaCategoryId, } from '@synisys/idm-kb-service-client-js';
import { mergeMap } from 'rxjs/operators';
import { isNil } from 'lodash';
var DeDocumentTokenProvider = /** @class */ (function () {
    function DeDocumentTokenProvider(classifierService, deService, kbService) {
        this.classifierService = classifierService;
        this.deService = deService;
        this.kbService = kbService;
        this.UPLOAD_PERMISSION_TYPE = 'UPLOAD';
    }
    DeDocumentTokenProvider.prototype.getDocumentAuthInfo = function (categorySystemName, id, documentSystemName) {
        var _this = this;
        return this.kbService
            .getMetaCategoryByMetaCategoryId(new MetaCategoryId(categorySystemName))
            .pipe(mergeMap(function (category) {
            if (category.getIsClassifier()) {
                return _this.classifierService.getDocumentAuthInfo(categorySystemName, id, documentSystemName);
            }
            else {
                return _this.deService.getDocumentToken(categorySystemName, id, documentSystemName);
            }
        }));
    };
    DeDocumentTokenProvider.prototype.getDocumentAuthInfoForUpload = function (categorySystemName, id, documentSystemName) {
        var _this = this;
        if (isNil(id)) {
            id = -1;
        }
        return this.kbService
            .getMetaCategoryByMetaCategoryId(new MetaCategoryId(categorySystemName))
            .pipe(mergeMap(function (category) {
            if (!category.getIsClassifier()) {
                return _this.deService.getDocumentToken(categorySystemName, id, documentSystemName, _this.UPLOAD_PERMISSION_TYPE);
            }
            throw new Error('Upload Document Auth Info is not supported for classifers');
        }));
    };
    DeDocumentTokenProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [ClassifierService,
            DeService,
            KbService])
    ], DeDocumentTokenProvider);
    return DeDocumentTokenProvider;
}());
export { DeDocumentTokenProvider };
//# sourceMappingURL=de-document-token-provider.service.js.map